module.exports = __webpack_public_path__ + "static/flags/SG-b373cb34ae27db76d4d6404462718af3.gif";